import gql from 'graphql-tag';

const ARTICLEGQL = `
uid
    titleOfTheBrowser
    metaTagSection {
      name
      content
    }
    articleTemplate {
      heading1
      subheading
      time_to_read
      breadcrumbs
      pageContent
      icon {
        url
        alternativeText
      }
      media {
        alt
        media {
          url
        }
        desktopImagePosition {
          position
        }
      }
    }
    elements {
      ... on ComponentElementsRecommendation {
        articleUID {
          uid
          externalUrl
          content {
            title
            icon {
              url
            }
            contentMedia {
              content
              media {
                media {
                  url
                }
              }
            }
          }
        }
        recommendation
        RecommendationHeading
      }
      ... on ComponentElementsNotification {
        types
        content
        link: hyperlink {
          alt
          label
          url
          contentUid
          targetContentSectionID
        }
      }

      ... on ComponentElementsMultiLevel {
        Level1 {
          Level1_title
          Level1_content
          Level1_media {
            media {
              url
            }
            desktopImagePosition {
              position
            }
          }
          Level2 {
            Level2_title
            Level2_content
            Level2_media {
              media {
                url
              }
              desktopImagePosition {
                position
              }
            }
            Level3 {
              Level3_title
              Level3_content
              Level3_media {
                media {
                  url
                }
                desktopImagePosition {
                  position
                }
              }
              Level4 {
                Level4_title
                Level4_content
                Level4_media {
                  media {
                    url
                  }
                  desktopImagePosition {
                    position
                  }
                }
              }
            }
          }
        }
      }
      ... on ComponentElementsGlobalComponent {
        __typename
        contentSectionID
        title
        copy
        genericComponent {
          uid
          title
          subtitle
          uid
          copy
          listOfContent {
            text
            content
          }
          faqs {
            UID
            heading
            content
          }
          icon {
            url
          }
          ctas {
            label
            alt
            url
            targetNewPage
            icon{
              url
            }
          }
          externalUrl
          listOfContent {
            text
            content
          }
          products {
            product_id
            description
            internal_name
          }
        }
      }
      ... on ComponentElementsGenericComponent {
        title
        subtitle
        copy
        ctas {
          label
          url
        }
        listOfContent {
          text
          content
        }
        listOfLinks {
          links {
            label
            icon {
              url
            }
            url
            alt
          }
        }
      }
      ... on ComponentElementsSupportOption {
        __typename
        mainHeading
        innerHeading
        innerSubHeading
        successMessage
        hyperlink {
          label
          targetNewPage
        }
        media {
          media {
            alternativeText
            url
          }
        }
        support_options {
          uid
          Heading
          subheading
          modal
          hyperlink {
            url
            targetNewPage
          }
          media {
            media {
              alternativeText
              url
            }
          }
          supportOptions {
            copy
          }
        }
      }
      ... on ComponentElementsPayOutstanding {
        __typename
        title
        breakdownTitle
      }
      ... on ComponentElementsHyperlink {
        Uid
        label
        url
      }
    }
`;

export const ARTICLE_QUERY = gql`
  query ArticleQuery($uid: String!) {
    articles(where: { uid: $uid }) {
      ${ARTICLEGQL}
    }
  }
`;

export const ARTICLES_OF_CATEGORY_QUERY = gql`
  query CategoryQuery($uid: String!) {
    categories(where: { uid: $uid }) {
      uid
      title
      statement
      category {
        uid
        title
      }
      articles {
        ${ARTICLEGQL}
      }
    }
  }
`;
